import React, { useState } from "react";

import { Formik, Form } from "formik";

import { useSetRecoilState } from "recoil";
import { snackbarData } from "recoilState/GlobalState";

import { migraUsuarioPasoUpd } from "services/services-mia/migra";
import { handleResponse } from "services/Local-services";
import { FormButton } from "components";
import { FormikSelectInput } from "components/UI/Inputs/FormikInputs";

import styles from "styles/pages/ModalActions.module.scss";

export default function SemaforoModal({ row, updateList, closeModal, credentials, setRowSelected }) {
    const [inRequest, setInRequest] = useState(false);
    const setSnackbarInfo = useSetRecoilState(snackbarData);

    const handleSubmit = async ({ migraUsuarioPasoSemaforo }) => {
        setInRequest(true);
        const response = await migraUsuarioPasoUpd(
            {
                migraUsuarioPasoId: row.migraUsuarioPasoId,
                migraUsuarioPasoSemaforo,
                migraUsuarioPasoIdentificacion: row.migraUsuarioPasoIdentificacion,
                migraUsuarioPasoOrigenDestino: row.migraUsuarioPasoOrigenDestino
            },
            credentials
        );
        handleResponse(response, "Semáforo actualizado exitosamente", {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected: setRowSelected,
            updateList,
        });
        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{ migraUsuarioPasoSemaforo: row.migraUsuarioPasoSemaforo || "V" }}
            onSubmit={handleSubmit}
        >
            <Form className={styles.inputs}>
                <div className={styles["column-sm"]}>
                    <FormikSelectInput name="migraUsuarioPasoSemaforo" labelText="Semáforo">
                        <option value="V">Verde</option>
                        <option value="A">Amarillo</option>
                        <option value="R">Rojo</option>
                    </FormikSelectInput>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
